import { useCallback, useEffect, useRef } from 'react';
import { easeIn, getMask } from './helpers';
import styles from './ScrollFade.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollFade = _ref => {
  let {
    size
  } = _ref;
  const rootRef = useRef(null);
  const onScroll = useCallback(() => {
    var _rootRef$current;
    const scrollElement = (_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.parentElement;
    if (scrollElement) {
      const {
        offsetHeight,
        scrollHeight,
        scrollTop
      } = scrollElement;
      const opacityTop = easeIn((scrollHeight - offsetHeight - scrollTop) / (offsetHeight - scrollHeight), 10);
      const opacityBottom = easeIn(scrollTop / (offsetHeight - scrollHeight), 10);
      const mask = getMask({
        opacityBottom,
        opacityTop,
        size
      });
      scrollElement.style.mask = mask;
      scrollElement.style.webkitMask = mask;
    }
  }, [size]);
  useEffect(() => {
    var _rootRef$current2;
    const scrollElement = (_rootRef$current2 = rootRef.current) === null || _rootRef$current2 === void 0 ? void 0 : _rootRef$current2.parentElement;
    if (!scrollElement) {
      return;
    }
    const {
      offsetHeight,
      scrollHeight
    } = scrollElement;
    if (offsetHeight !== scrollHeight) {
      const mask = getMask({
        opacityBottom: 0,
        opacityTop: 1,
        size
      });
      scrollElement.style.mask = mask;
      scrollElement.style.webkitMask = mask;
    }
    scrollElement.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => scrollElement.removeEventListener('scroll', onScroll);
  }, [onScroll, size]);
  return /*#__PURE__*/_jsx("span", {
    className: styles['container'],
    ref: rootRef
  });
};